import React from 'react'
import { Link, useParams } from 'react-router-dom';
import { useSingleOrderDetail } from '../../../hooks/store/orders';
import {ArrowRight,ArrowLeft,Clock,Calendar} from 'lucide-react'
import { useTranslation } from 'react-i18next';
import { OrderStatus } from '../../../types/enum/orderStatus';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import PriceText from '../../../components/ui/PriceText';
import DateTimeText from '../../../components/ui/DateTimeText';
import { useUpdateResource } from '../../../hooks/useUpdateResource';

function OrderDetailsPage() {
    const {i18n , t} = useTranslation();
    const { orderId , storeId} = useParams<{ orderId: string , storeId: string}>();
   const numericOrderId = orderId ? parseInt(orderId) : 0;
   const numericStoreId = storeId ? parseInt(storeId) : undefined;
   const {data:order,isLoading,isError} = useSingleOrderDetail(numericOrderId,numericStoreId);

    const {loading,updateResource} = useUpdateResource();
       
         const handleAcceptOrder = async () => {
               await  updateResource(`order/admin/received/${numericOrderId}`,{}, "admin",{
                   method: "PUT",
                   successMessage: t("updatedSuccess"),
                   invalidateQueries:["order-detail","store-orders"],
                   confirmMessage:t('confirm_complete_order')
                 });
         };

          const handleCancelOrder = async () => {
               await  updateResource(`order/admin/cancel/${numericOrderId}`,{}, "admin",{
                   method: "PUT",
                   successMessage: t("updatedSuccess"),
                   invalidateQueries:["order-detail"],
                   confirmMessage:t('confirm_cancel_order')
                 });
         };

  return (
    <div className=' container p-6 h-[100vh] overflow-auto'>
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
       { order && 
        <div className=' max-w-[1100px] mx-auto'>
            <div className='flex justify-between'>
                <div>
                    <h3 className=' text-[16px] font-black text-Black'>#{order.orderNumber}</h3>
                    <p className='text-[12px] font-medium text-DarkGrey3'>{t('order_no')}</p>
                </div>
                <Link to={"/store/orders"}>
                    {i18n.language ==="en" ?<ArrowRight size={22} className='text-Black'/> :<ArrowLeft className='text-Black'/>}
                </Link>
            </div>
            {/* customer card */}
            <div className=' bg-[#FFFFFF] shadow-custom-light p-4 rounded-2xl mt-7 flex justify-between items-end'>
                <div className=' flex gap-3'>
                    <img 
                    className='w-[80.6px] h-[80.6px] rounded-full object-contain'
                    src={order.customer.imageUrl?order.customer.imageUrl:order.customer.avatar?.url||""} alt="" />
                    <div className="flex flex-col justify-between">
                        <h3 className=' text-[16px] font-black text-Black'>{order.customer.name}</h3>
                        <p className='flex items-center gap-1 text-[14px] text-Black font-medium'>
                            <Clock size={20} className=' text-DarkGrey2'/> <span>{order.estimatedTime} {t('mins')}</span>
                        </p>
                    </div>
                </div>
                <div>
                    <p className=' text-Black  font-medium text-[14px]'>{t(order.pickupType)}</p>
                </div>
            </div>

            {/* order info */}
            <div className='bg-[#FFFFFF] shadow-custom-light p-4 rounded-2xl mt-7'>
                <div className=' flex justify-between items-center px-4 py-3 flex-wrap'>
                    {
                        order.status===OrderStatus.received ?
                        <div className='flex gap-2 items-center'>
                            <img src="/order_complete.png" alt="" />
                            <p className=' text-primaryButton font-bold capitalize'>{t('good_job')}</p>
                        </div>
                        :
                        (order.status === OrderStatus.cancelled || order.status===OrderStatus.expired_confirmation || order.status===OrderStatus.rejected) 
                        ?
                        <div className='flex gap-2 items-center'>
                            <img src="/order_cancelled.png" alt="" />
                            <p className=' text-Red font-bold capitalize'>{t('order_missed')}</p>
                        </div>
                        :
                        <div className='flex items-center gap-2'>
                            <button 
                            onClick={handleAcceptOrder}
                            className=' bg-primaryButton text-white px-2 py-2 flex items-center justify-center rounded-2xl duration-300 hover:bg-opacity-85'>
                                {t('complete_order')}
                            </button>
                            <button 
                            onClick={handleCancelOrder}
                            className=' bg-Red text-white px-2 py-2 flex items-center justify-center rounded-2xl duration-300 hover:bg-opacity-85'>
                                {t('cancel_order')}
                            </button>
                        </div>
                    }
                    <div className='flex items-center gap-1 text-DarkGrey2 text-[12px]'>
                        <Calendar size={14}/>
                        <DateTimeText date={order.createdAt}/>
                        {/* <p>{formatDateTime(order.createdAt)}</p> */}
                    </div>
                </div>
                <div className=' rounded-xl bg-LightGrey1 py-3 px-4 flex items-center justify-between mt-3'>
                    <h4 className=' text-Black font-medium capitalize'>{t('total_amount')}</h4>
                    <div className='flex items-start gap-1'>
                        <img src='/Vector2.png' alt="" className='w-[10.67px] h-[11.95px]'/>
                        <PriceText value={order.finalPriceToPay}/>
                        {/* <span className=' text-Black font-black text-[24px]'>{order.finalPriceToPay.toFixed(2)}</span> */}
                    </div>
                </div>
                <div className=' px-4 py-3 mt-3 flex items-center justify-between'>
                    <div className='flex items-center gap-2'>
                        <h3 className=' text-Black capitalize font-medium text-[12px]'>{t('order_no')}</h3>
                        <span className=' text-Black font-bold'>#{order.orderNumber}</span>
                    </div>
                    <div >
                        {
                        order.status === OrderStatus.received ? (
                            <span className="px-2 py-2 flex items-center justify-center rounded-tl-[20px] rounded-tr-[8px] rounded-br-[20px] rounded-bl-[8px] w-[96px] text-xs bg-primaryButton text-white">
                            {t("completed")}
                            </span>
                            ) : 
                            (order.status === OrderStatus.cancelled || order.status===OrderStatus.expired_confirmation || order.status===OrderStatus.rejected) && (
                            <span className="px-2 py-2 flex items-center justify-center rounded-tl-[20px] rounded-tr-[8px] rounded-br-[20px] rounded-bl-[8px] w-[96px] text-xs bg-Red text-white">
                            {t("cancelled")}
                            </span>
                            ) 
                        }
                    </div>
                </div>
            </div>

            {/* order items */}
            <div className=' mt-7'>
                <div className='flex justify-between gap-4 items-center'>
                    <div className=' text-Black font-black'>
                        <h3>{t('items')}</h3>
                    </div>
                    <span className=' h-[2px] bg-LightGrey3 block w-full flex-1'></span>
                    <div className='flex gap-1 items-center'>
                        <span className=' text-Black font-black text-[12px]'>{order.orderItems.length<10 ?`0${order.orderItems.length}`: order.orderItems.length}</span>
                        <span className=' text-Black font-medium text-[12px]'>{t('items')}</span>
                    </div>
                </div>
                <div className=' grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mt-7 justify-center gap-4'>
                    {
                    order.orderItems.map(item=>{
                        return<div key={item.id+"order item"} className=' shadow-custom-light bg-white rounded-[20px] overflow-hidden w-fit'>
                            <div>
                                <img src={item.images[0]} alt="" />
                            </div>
                            <div className=' p-2'>
                                <h4 className=' text-[16px] font-semibold text-Black'>{item.productName}</h4>
                                <span className=' font-meduim text-DarkGrey3'>{item.extras.map(extra => extra.name).join(", ")}</span>
                            </div>
                        </div>
                    })
                    }                    
                </div>
            </div>
        </div>}
         {/* Overlay */}
      {loading && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
    </div>
  )
}

export default OrderDetailsPage